import SectionContent from "./SectionContent";
import useWindowSize from "@hooks/useWindowSize";
import { discoverPage } from "@utils/helper";
import { usePageContext } from "@providers/PageProvider";
import _ from "lodash";
const View = () => {
  const { width = 1280 } = useWindowSize();
  const isMobile = width! <= 576;
  const { pageData } = usePageContext();
  const data = discoverPage.formatRecommendation(pageData);
  return (
    <SectionContent
      type="right"
      className={isMobile ? "no-padding-top" : ""}
      content={_.get(data, "content")}
      title={_.get(data, "title")}
      image={_.get(data, "image")}
      border="none"
    />
  );
};
export default View;
